import { computed, defineComponent, ref, useCssModule } from '@nuxtjs/composition-api';
import { TEXTS } from '~/components/BrandVoiceAbout';
export default defineComponent({
    name: 'BrandVoiceMobile',
    props: {
        pageOffset: {
            default: 0,
            type: Number,
        },
        tax: {
            required: true,
            type: Object,
        },
    },
    setup(props, { emit }) {
        /**
         * CSS Composables.
         */
        const css = useCssModule();
        const tabsTitles = [];
        if (props.tax?.articles?.length) {
            tabsTitles.push('Статьи');
        }
        const currentText = computed(() => TEXTS[props.tax?.url?.replace('brandvoice/', '') || '']) || {};
        tabsTitles.push(currentText.value?.caption || 'О компании');
        const currentTab = ref({
            title: tabsTitles[0],
        });
        emit('changeTab', {
            title: tabsTitles[0],
        });
        const tabs = computed(() => {
            return tabsTitles.map((title) => {
                return {
                    title,
                };
            });
        });
        const currentTabComponent = computed(() => {
            if (currentTab.value.title === 'Статьи') {
                return {
                    attrs: {
                        'page-offset': props.pageOffset,
                        tax: props.tax,
                    },
                    component: () => import('~/components/BrandVoiceGridMobile/BrandVoiceGridMobile.vue'),
                };
            }
            return {
                attrs: {
                    tax: props.tax,
                    text: currentText.value,
                },
                component: () => import('~/components/BrandVoiceAbout/BrandVoiceAbout.vue'),
            };
        });
        function changeTab(tab) {
            currentTab.value = tab;
            emit('changeTab', tab);
        }
        return {
            changeTab,
            css,
            currentTab,
            currentTabComponent,
            currentText,
            tabs,
            tabsTitles,
        };
    },
});
